
<div class="m-6 flex flex-col sm:grid sm:grid-flow-row-dense
    sm:grid-cols-3
    gap-6">
    <div #paymentGroup class="admin-group-card">
        <mat-list class="grid
            max-sm:divide-y
            sm:gap-3">
            <h3><b>Payment</b></h3>
            <mat-list-item class="admin-list-item" routerLink="payment-config">
                <div mat-line
                    class="admin-item-title">
                    Payment Configuration
                </div>
            </mat-list-item>
            <mat-list-item class="admin-list-item" routerLink='payment-check'>
                <div mat-line
                    class="admin-item-title">
                    OeBS Check Payment Processing
                </div>
            </mat-list-item>
            <mat-list-item class="admin-list-item" routerLink="payment-credit">
                <div mat-line
                    class="admin-item-title">
                    OeBS Credit Card Payment Processing
                </div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink="payment-foundation-trustee">
                <div mat-line
                    class="admin-item-title">
                    Foundation Trustee Payment Processing</div>
            </mat-list-item>
        </mat-list>

    </div>
    <div #externalGroup class="admin-group-card">
        <mat-list class="grid
            max-sm:divide-y
            sm:gap-3">
            <h3><b>External</b></h3>
            <mat-list-item class="admin-list-item"
                routerLink="external-users-management">
                <div mat-line
                    class="admin-item-title">
                    Site Users</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item" routerLink="form-status">
                <div mat-line
                    class="admin-item-title">
                    Award/Decline Requests</div>
            </mat-list-item>
        </mat-list>
    </div>
    <div #configGroup class="admin-group-card">
        <mat-list class="grid
            max-sm:divide-y max-sm:divide-2
            sm:gap-6">
            <h3><b>Configurations</b></h3>
            <mat-list-item class="admin-list-item"
                routerLink='accounting-distribution-external'>
                <div mat-line
                    class="admin-item-title">Accounting Distribution
                    Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink='alm-configuration'>
                <div mat-line
                    class="admin-item-title">Authority Limit Matrix (ALM)
                    Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink='ein-configuration'>
                <div mat-line
                    class="admin-item-title">Accounting Distribution
                    Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink="ein-configuration">
                <div mat-line
                    class="admin-item-title">
                    EIN Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink="email-configuration">
                <div mat-line
                    class="admin-item-title">
                    Email Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink="form-configuration">
                <div mat-line
                    class="admin-item-title">
                    Form Configuration</div>
            </mat-list-item>
            <mat-list-item class="admin-list-item"
                routerLink="override-reporting-hierarchy">
                <div mat-line
                    class="admin-item-title">
                    Override Reporting Hierarchy</div>
            </mat-list-item>
        </mat-list>

    </div>
    <div #BI class="admin-group-card flex flex-col space-y-4 sm:grid
        sm:grid-cols-4
        sm:gap-5
        justify-center
        content-center items-center">
        <div class="max-sm:w-full sm:col-span-4">
            <h3><b>CCMS BI reports</b></h3>

        </div>
        <mat-form-field class="max-sm:w-full sm:col-span-3">
            <mat-label>Report: </mat-label>
            <mat-select placeholder="Report"
                [(ngModel)]='selectedReport'>
                <mat-option *ngFor="let rpt of reports"
                    [value]="rpt.value">{{rpt.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" class="max-sm:w-full"
            [disabled]="selectedReport === ''"
            (click)="onOpenReport()">Open</button>
        <mat-card *ngIf="hasRole('DEV')" class="col-span-4 !bg-[#66bb6a]
            items-center
            content-center
            max-sm:w-full"
            (click)="onUpdateSubsection()">
            Update Subsection list
        </mat-card>
    </div>
    <div #EmployeeHierarchy class="admin-group-card sm:col-span-2">
        <h3><b>Employee Hierarchy</b></h3>
        <div class="w-full flex flex-col">
            <form [formGroup]="employeeInfo" class="grid grid-rows-2
                sm:grid-cols-4 gap-6">
                <button mat-raised-button color="primary"
                    [disabled]="employeeInfo.invalid" (click)="onSubmit()">Get
                    Emp Hierarchy</button>
                <mat-form-field class="sm:col-span-3">
                    <mat-label>Employee Id: </mat-label>
                    <input type="text" placeholder="Employee Id"
                        maxlength="7" matInput required
                        formControlName="EmpId">
                </mat-form-field>
            </form>
            <div class="w-full" *ngIf="employeeData != 0">
                <mat-vertical-stepper [linear]="false"
                    (selectionChange)="onStepChange($event, stepper)" #stepper>
                    <mat-step *ngFor="let employee of employeeData" class="grid
                        divide divide-y divide-green-500 justify-center
                        items-start
                        content-start">
                        <ng-template matStepLabel>{{ employee.EmpName }}</ng-template>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Emp Name: {{ employee.EmpName }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Emp Id: {{ employee.EmpId }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Emp Type: {{ employee.EmpType }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Emp Email: {{ employee.Email}}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Department: {{ employee.DepartmentName }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Manager ID: {{ employee.Manager }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Manager Name: {{ employee.ManagerName }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            Manager Email: {{ employee.MgrEmail }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            DOA: {{ employee.DelegatedTo }}
                        </div>
                        <div class="bg-gray-200/75 p-6
                            hover:bg-green-200 hover:border-l-4
                            hover:border-green-700 h-20">
                            DOA Name: {{ employee.DelegatedToName }}
                        </div>
                    </mat-step>
                </mat-vertical-stepper>
            </div>
        </div>
    </div>
</div>

<!-- <div fxLayout="row" fxLayoutGap="16px">
            <mat-card class="matcardButton" routerLink='accounting-distribution' style="flex-grow: 2;">
                Accounting Distribution Configuration
            </mat-card>
            <mat-card class="matcardButton" routerLink='accounting-distribution' style="flex-grow: 1;">
                Internal Accounting Distribution Configuration
            </mat-card>
            <mat-card class="matcardButton"
                routerLink='accounting-distribution-external' style="flex-grow:
                2;">
                Accounting Distribution Configuration
            </mat-card>
        </div> -->
<!-- <mat-card class="matcardButton" routerLink="alm-configuration">
            Authority Limit Matrix (ALM) Configuration
        </mat-card> -->
<!-- <mat-card class="matcardButton" routerLink="ein-configuration">
            EIN Configuration
        </mat-card>
        <mat-card class="matcardButton" routerLink="email-configuration">
            Email Configuration
        </mat-card>
        <mat-card class="matcardButton" routerLink="form-configuration">
            Form Configuration
        </mat-card>
        <mat-card class="matcardButton"
            routerLink="override-reporting-hierarchy">
            Override Reporting Hierarchy
        </mat-card> -->
<!-- <mat-card class="admin-list-item" routerLink="payment-config">
            Payment Configuration
        </mat-card>
        <mat-card fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
            <div style="flex-grow: 2;">OeBS Payment Processing</div>
            <button mat-button routerLink='payment-check' style="flex-grow: 1;">
                Check
            </button>
            <button mat-button routerLink='payment-credit' style="flex-grow:
                1;">
                Credit Card
            </button>
        </mat-card>
        <mat-card class="matcardButton" routerLink="payment-foundation-trustee">
            Foundation Trustee Payment Processing
        </mat-card>
        <mat-card class="matcardButton" routerLink="external-users-management">
            Site Users
        </mat-card>
        <div fxLayout="column" routerLink="form-status" fxLayoutGap="16px">
            <mat-card class="matcardButton">
                Award/Decline Requests
            </mat-card>
        </div>
        <mat-card fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
            <div fxFlex="60%" fxLayoutAlign="stretch">
                CCMS BI reports
            </div>
            <div fxFlex="40%" fxLayoutAlign="stretch" fxLayoutGap="12px"
                fxLayout.lt-sm="column" style="overflow: auto">
                <mat-form-field fxFlex="70%" fxLayoutAlign="stretch"
                    fxLayout="column">
                    <mat-label>Report: </mat-label>
                    <mat-select placeholder="Report"
                        [(ngModel)]='selectedReport'>
                        <mat-option *ngFor="let rpt of reports"
                            [value]="rpt.value">{{rpt.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button color="primary"
                    [disabled]="selectedReport === ''"
                    (click)="onOpenReport()">Open</button>
            </div>
        </mat-card> -->
<!-- <div fxLayout="row" fxLayoutGap="16px">
            <mat-card class="matcardButton" style="flex-grow: 2;">
                Email Notification For Outstanding Task (For Test Only)
            </mat-card>
            <mat-card class="matcardButton" (click)="NotifyApprovarForOutstandingTask()" style="flex-grow: 1;">
                Send Email
            </mat-card>
            <mat-card class="matcardButton" (click)="ResetApprovarForOutstandingTask()" style="flex-grow: 1;">
                Reset
            </mat-card>
        </div>
        <div fxLayout="row" fxLayoutGap="16px">
            <mat-card class="matcardButton" style="flex-grow: 2;">
                Email Notification For DOA (For Test Only)
            </mat-card>
            <mat-card class="matcardButton" (click)="GetDOAForApprover()" style="flex-grow: 1;">
                Send Email
            </mat-card>
            <mat-card class="matcardButton" (click)="ResetGetDOAForApprover()" style="flex-grow: 1;">
                Reset
            </mat-card>
        </div> -->